import {Suspense, lazy} from 'react'
import {Redirect, Route, Switch} from 'react-router-dom'
import {FallbackView} from '../../_metronic/partials'
import {DashboardRouter} from './internal/DashboardRouter'
import FinancialRouter from './internal/FinancialRouter'
import AccessRouter from './internal/AccessRouter'
import ManagementsRouter from './internal/ManagementRouter'

export function PrivateRoutes() {
    const ProfilePage = lazy(() => import('../pages/profile'))
    const ShowRepresentative = lazy(() => import('../pages/pdvs/ShowRepresentative'))

    return (
        <Suspense fallback={<FallbackView />}>
            <Switch>
                <Route path='/meu-perfil' component={ProfilePage} />
                <Route path='/representative' component={ShowRepresentative} />

                <Route path='/painel' component={DashboardRouter} />
                <Route path='/gestao' component={ManagementsRouter} />
                <Route path='/acesso' component={AccessRouter} />
                <Route path='/financeiro' component={FinancialRouter} />

                <Redirect from='/autenticacao' to='/painel/administrativo' />
                <Redirect exact from='/' to='/painel/administrativo' />
                <Redirect to='error/404' />
            </Switch>
        </Suspense>
    )
}
